import { createContext, useContext } from "react";

// Create context for share data
const ShareContext = createContext(null);

// Provider component
export const ShareProvider = ({
  children,
  device,
  deviceHistory,
  deviceProfile,
  shareId,
}) => {
  const value = {
    device,
    deviceHistory,
    deviceProfile,
    shareId,
    isShareMode: true,
  };

  return (
    <ShareContext.Provider value={value}>{children}</ShareContext.Provider>
  );
};

// Hook to use share context
export const useShareContext = () => {
  const context = useContext(ShareContext);
  return context; // Return null if not in share context
};

// Custom hook to check if we're in share mode
export const useIsShareMode = () => {
  const context = useShareContext();
  return context?.isShareMode || false;
};
